<template>
  <div class="batch-PDF-uploading">
    <el-scrollbar>
      <div class="progress-area">
        <div class="progress-area-item" v-for="(item, index) in files" :key="index">
          <div class="file">
            <div class="name">{{ item.name }}</div>
            <img v-if="type === 'merge' && uploadState !== 'batchUploading'" class="delete" src="@imgs/icon_cancel.png" @click="deleteHandler(index)" />
          </div>
          <div v-if="uploadState === 'batchUploading' || type === 'batch'" class="progress">{{ item.percentage }}%</div>
          <div v-if="uploadState === 'done' && type === 'merge'" class="operations">
            <img class="operations-item" src="@imgs/bookshelfedit/MoveTop.png" title="置顶" @click="handleMove('first', index)" alt="" />
            <img class="operations-item" src="@imgs/bookshelfedit/icon_up.png" title="上移" @click="handleMove('previous', index)" alt="" />
            <img class="operations-item" src="@imgs/bookshelfedit/icon_down.png" title="下移" @click="handleMove('next', index)" alt="" />
            <img class="operations-item" src="@imgs/bookshelfedit/MoveBottom.png" title="置底" @click="handleMove('last', index)" alt="" />
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="operation-area">
      <div v-if="type === 'batch'" class="button-handler confirm-button-handler" :class="{ disabled: uploadState === 'batchUploading' }" @click="uploadHandler('batch')">
        {{ pdfType === 'paper' ? '生成数字报' : '生成电子书' }}
      </div>
      <div v-if="type === 'merge'" class="button-handler confirm-button-handler" :class="{ disabled: uploadState === 'batchUploading' }" @click="uploadHandler('merge')">
        {{ pdfType === 'paper' ? '合成数字报' : '合成电子书' }}
      </div>
      <div v-if="type === 'merge'" class="button-handler delete-button-handler" :class="{ disabled: uploadState === 'batchUploading' }" @click="deleteHandler(-1)">全部删除</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import setBook from '@api/setBook'
export default {
  name: 'batchPDFUploading',
  props: {
    type: {
      default: 'batch',
      type: String
    },
    uploadState: {
      default: ''
    },
    paperType: {
      default: function() {
        return '0'
      }
    },
    pdfType: {
      type: String,
      default: function() {
        return 'book'
      }
    },
    replaceId: {
      default: ''
    }
  },
  data() {
    return {
      show: true
    }
  },
  computed: {
    ...mapState('config', {
      open: (state) => state.bookObj.open,
      dpi: (state) => state.bookObj.dpi,
      referer: (state) => state.bookObj.referer,
      displayPageNo: (state) => state.bookObj.displayPageNo
    }),
    files() {
      return this.$store.state.book.batchPDFFiles
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  watch: {
    files(newVal) {
      let arr = Object.values(newVal)
      let l = arr.length
      for (let i = 0; i < l; ) {
        if (arr[i].status === 'success') {
          i++
          if (i === l) {
            this.status = success
          }
        } else {
          i = l
        }
      }
    }
  },
  methods: {
    handleMove(type, index) {
      let currentValue = this.files[index]
      let displaceIndex = 0
      switch (type) {
        case 'first':
          if (index > 0) {
            this.files.splice(index, 1)
            this.files.unshift(currentValue)
          }
          break
        case 'last':
          if (index < this.files.length - 1) {
            this.files.splice(index, 1)
            this.files.push(currentValue)
          }
          break
        case 'previous':
          displaceIndex = index === 0 ? 0 : index - 1
          if (index !== displaceIndex) {
            this.$set(this.files, index, this.files[displaceIndex])
            this.$set(this.files, displaceIndex, currentValue)
          }
          break
        case 'next':
          displaceIndex = index === this.files.length - 1 ? this.files.length - 1 : index + 1
          if (index !== displaceIndex) {
            this.$set(this.files, index, this.files[displaceIndex])
            this.$set(this.files, displaceIndex, currentValue)
          }
          break
      }
    },
    // 批量batch 合并merge生成电子书
    uploadHandler(type) {
      if (this.uploadState !== 'done') {
        return
      }
      const pdfType = (this.pdfType === 'paper' ? this.pdfType : '') + (this.replaceId ? 'Replace' : '')
      const currentApi = setBook[`${type}PDF${pdfType}`]
      let param = {
        ids: '', //是	String	pdf上传文件md5值串，中间用,隔开
        fileName: '', //是	String	排序第一位的电子书名
        dpi: this.dpi, //是	int	当前精度，默认180L
        open: this.open, //	是	int	公开展示。0-否，1-是，默认0
        referer: this.referer, //	是	int	页面展示参考页码，默认1
        displayPageNo: this.displayPageNo, //	是	int	展示范围，0-全部，大于0-指定页码，默认全部
        userName: this.userName
      }
      if (this.pdfType === 'paper') {
        param.baozhiId = this.paperType
      }
      this.files.forEach((item, index) => {
        if (index === 0) {
          param.ids = item.uuid
          param.fileName = item.name
        } else {
          param.ids += `,${item.uuid}`
        }
      })
      if (this.replaceId) {
        param.worksId = this.replaceId
      }

      currentApi(param)
        .then((res) => {
          if (res && res.data && res.status === 200 && (res.data.code === 0 || res.data.status === 0)) {
            this.$router.push({ name: 'list', params: { to: this.pdfType }, query: { sourceSite: 1 } })
          } else {
            this.$message({
              message: res.message || '上传失败',
              type: 'error'
            })
          }
        })
        .catch((err) => {
          this.$message({
            message: err.toString() || '上传失败',
            type: 'error'
          })
        })
    },
    deleteHandler(index) {
      if (this.uploadState !== 'done') {
        return
      }
      if (index !== -1) {
        this.files.splice(index, 1)
        if (this.files.length === 0) {
          this.$emit('updateState', 'ready')
        }
      } else {
        this.files.splice(0, this.files.length)
        this.$emit('updateState', 'ready')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.batch-PDF-uploading {
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 8px;
  /deep/ .el-scrollbar {
    width: 100%;
    padding: 17px 0;
    .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }
  }
  .progress-area {
    height: 100%;
    flex: 1;
    padding: 0 25px;
    .progress-area-item {
      border-bottom: 1px solid #eee;
      height: 34px;
      line-height: 34px;
      color: #3a3a3a;
      font-size: 14px;
      display: flex;
      align-items: center;
      .file {
        padding-right: 30px;
        flex: 1;
        width: 0;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        .name {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .delete {
          width: 11px;
          height: 11px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .progress {
        width: 50px;
      }
      .operations {
        display: inline-flex;
        width: 80px;
        justify-content: space-between;
        .operations-item {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }
      }
    }
  }
  .operation-area {
    width: 150px;
    height: 100%;
    background-color: #fff7ed;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .button-handler {
      border-radius: 3px;
      text-align: center;
      font-size: 14px;
      box-sizing: border-box;
      cursor: pointer;
      &.confirm-button-handler {
        width: 100px;
        height: 32px;
        line-height: 32px;
        background-color: #fab15e;
        color: #ffffff;
        &.disabled {
          background-color: #cecece;
        }
      }
      &.delete-button-handler {
        width: 80px;
        height: 28px;
        line-height: 26px;
        margin-top: 18px;
        background-color: #ffffff;
        color: #fab15e;
        border: 1px solid #fab15e;
        &.disabled {
          color: #cecece;
          border-color: #cecece;
        }
      }
    }
  }
}
</style>
